import { render, staticRenderFns } from "./Departments.vue?vue&type=template&id=208426fc"
import script from "./Departments.vue?vue&type=script&lang=ts"
export * from "./Departments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports